import { h, Component } from 'preact';

import style from '../../style/header.sass';

export default class HeaderImage extends Component {
  render(props, state) {
    if(!props.mergedLandingPageData){
      return null;
    }
    return (
      <img className={style.image} src={props.mergedLandingPageData.header_air_swoosh_image_url} />
    );
  }
}